export const _en = {
    startValidityDate: {
        label: "Start date of validity date"
    },
    finishValidityDate: {
        label: "Finish date of validity date"
    },
    isEnable: {
        label: "Is enable"
    },
    refResourceTypeId: {
        label: "Resource type"
    },
    refDivisionId: {
        label: "Division"
    },
    refSiteId: {
        label: "Site"
    },
    resourceId: {
        label: "Resource"
    }
};

export const _fr = {
    startValidityDate: {
        label: "Date de début de validité"
    },
    finishValidityDate: {
        label: "Date de fin de validité"
    },
    isEnable: {
        label: "Situation active"
    },
    refResourceTypeId: {
        label: "Type de la ressource"
    },
    refDivisionId: {
        label: "Service"
    },
    refSiteId: {
        label: "Site"
    },
    resourceId: {
        label: "Ressource"
    }
};